import N8nBadge from './Badge.vue';

export default N8nBadge;
